import { useGridDefinitions } from "@/controls/ag-grid/components/GridDefinitions";
import { CenteredLazyLoading } from "@/controls/LazyLoading";
import { useTableData } from "@/pages/chemistries/report/hooks/hooks";
import { ChemistryRow } from "@/pages/chemistries/report/models/ChemistryRow";
import { Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";

type Props = {
	rows: ChemistryRow[];
	isLoading: boolean;
};

export const LastChemistriesTable = ({ rows, isLoading }: Props) => {
	const { columns } = useTableData(rows);
	const { defaultColDef } = useGridDefinitions({});

	return (
		<Paper
			elevation={2}
			sx={{
				height: "39vh",
				width: "100%",
				"& .ag-cell": { fontSize: 11 },
			}}
		>
			<AgGridReact<ChemistryRow>
				loading={isLoading}
				rowData={rows}
				columnDefs={columns}
				defaultColDef={defaultColDef}
				rowHeight={32}
				headerHeight={34}
				animateRows
				tooltipShowDelay={0}
				loadingOverlayComponent={CenteredLazyLoading}
				getRowId={(params) => String(params.data.HeatId)}
			/>
		</Paper>
	);
};
